// js
import SecurityOverview from '../../components/analytics/SecurityOverview';
import { connect } from 'react-redux';
import { getSecurityOverviewAggregateData, getCriticalSecurityCorrelationsCount } from '../../selectors/analytics/securitySelectors';


const mapStateToProps = state => {
  return {
    aggregateData: getSecurityOverviewAggregateData(state),
    criticalCorrelationCount: getCriticalSecurityCorrelationsCount(state)
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(SecurityOverview);



// WEBPACK FOOTER //
// ./src/containers/analytics/SecurityOverview.js